"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @hidden
 */
exports.DialogTitleBar = function (_a) {
    var children = _a.children, onCloseButtonClick = _a.onCloseButtonClick, id = _a.id, closeIcon = _a.closeIcon;
    return (React.createElement("div", { className: "k-window-titlebar k-dialog-titlebar k-header", id: id },
        React.createElement("div", { className: "k-window-title k-dialog-title" }, children),
        React.createElement("div", { className: "k-window-actions k-dialog-actions" }, closeIcon &&
            React.createElement("a", { href: "#", role: "button", "aria-label": "Close", onClick: onCloseButtonClick, className: "k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close" },
                React.createElement("span", { className: "k-icon k-i-x" })))));
};
//# sourceMappingURL=DialogTitleBar.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dialogs@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-dialogs/dist/npm/DialogTitleBar.js
// module id = 6534
// module chunks = 0